/**
 * The Exchange Online step of an app-only connect, as PowerShell the tenant admin can paste.
 *
 * Admin consent creates our service principal in their tenant but grants it nothing in Exchange;
 * this scopes the app to exactly one mailbox with RBAC for Applications. It deliberately filters
 * on `EmailAddresses` (Microsoft: "Don't use the PrimarySmtpAddress property; use the EmailAddresses
 * property instead") and never grants a tenant-wide Mail.* permission in Entra, which would union
 * with the scoped grant and make the scope meaningless.
 */
export function powershell_setup_script(app_id: string, mailbox: string): string {
  const scope_name = `MarginWiz ${mailbox}`
  return [
    `# Run in PowerShell 7 with the ExchangeOnlineManagement and Microsoft.Graph modules installed.`,
    `Connect-MgGraph -Scopes "Application.Read.All"`,
    `Connect-ExchangeOnline`,
    ``,
    `# MarginWiz's service principal in your tenant (created when you granted consent).`,
    `$app = Get-MgServicePrincipal -Filter "appId eq '${app_id}'"`,
    `New-ServicePrincipal -AppId $app.AppId -ObjectId $app.Id -DisplayName "MarginWiz"`,
    ``,
    `# Limit the app to this one mailbox.`,
    `New-ManagementScope -Name "${scope_name}" -RecipientRestrictionFilter "EmailAddresses -eq 'smtp:${mailbox}'"`,
    `New-ManagementRoleAssignment -App $app.Id -Role "Application Mail.ReadWrite" -CustomResourceScope "${scope_name}"`,
    `New-ManagementRoleAssignment -App $app.Id -Role "Application Mail.Send" -CustomResourceScope "${scope_name}"`,
    ``,
    `# Confirms the assignment immediately; live requests can take up to two hours to follow.`,
    `Test-ServicePrincipalAuthorization -Identity $app.Id -Resource "${mailbox}" | Format-Table`,
  ].join("\n")
}
